# ------------------------------------*|
#     #Section service
# ------------------------------------*|


moduleSection = angular.module 'api.sectionemail', []

moduleSection.factory 'SectionEmail', ["$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "$rootScope", ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, $rootScope) ->
  createPublic: (params) ->
    Restangular.all("sections").post params
  savePublic: (section) ->
    id = section.id+""
    Restangular.all("sections").one(id).customPUT section
  createItem: (section, params, isPublic = false) ->
    id = section.id+""
    if isPublic
      Restangular.all("sections").one(id).customPUT params
    else
      Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT params
  destoyItem: (section, imageId) ->
    id = section.id
    Restangular.all("sections").one(id).all("images").one(imageId).customDELETE()
  create: (id, type) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").post {section_id: id, section_type: type}
  clone: (id, type) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections/clone").post {section_id: id, section_type: type}
  save: (layout) ->
    section = layout.section
    @beforeSave layout
    section.structure = @generateJSON layout.one(ns.wrapperClass)
    id = layout.section.id+""
    isPublic = section.is_template
    if isPublic
      @savePublic section
    else
      Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT section
  saveAllSectionsAndPublish: (sections) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("batch_update").customPUT {sections: sections}
  getBuildStatus:() ->
    Restangular.all("emails").one($state.params.emailId).one("build_status").get();
  saveAllSectionsAndPublishPreview: (sections) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("save_preview").customPUT {sections: sections}
  saveSettings: (section) ->
    section = angular.copy section
    delete section.structure
    delete section.background_attributes.images_attributes
    if section.is_template
      @savePublic section
    else
      id = section.id+""
      Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT section
  remove: (id) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT {removed: true}
  removePublic: (id) ->
    Restangular.all("sections").one(id).customDELETE()
  restore: (id) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(id).customPUT removed: false
  removeBg: (section) ->
    section = angular.copy section
    section.remove_background = true
    if section.is_template
      Restangular.all("sections").one(section.id).customPUT section
    else
      Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(section.id).customPUT section
  sort: (sectionsIds) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").all("sort").post sections: sectionsIds
  get: (id) ->
    Restangular.all("emails").one(id).get()
  getHTML: (section) ->
    Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).all("sections").one(section.id+".html").get()
  getPublicSectionHTML: (id) ->
    Restangular.all("sections").one(id+".html").get()
  getPublicSectionStylesheet: ->
    id = $state.params.sectionId
    Restangular.all("sections").one(id+".css").get()
  getCollection: (category, colors) ->
    Restangular.one("sections").get {tag: category, for_email: true, "color[]": colors}
  getCategories: (email_id) ->
    Restangular.all("sections").all("tags").getList {email_id: email_id}
  getSections: ->
    Restangular.all("sections").one("all").get()
  beforeSave: (layout) ->
    @setTextContents layout
  setTextContents: (layout) ->
    Y = $rootScope.Y
    layout.all(
      [ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')
    ).each (block) ->
      content = block.one(ns.widgetWrapperClass).getHTML()

      # Very strange behaviour, sometimes the widget has property with empty name, and it produces an error while saving a page
      Object.keys(block.widget).forEach (k) ->
        k == '' and delete block.widget[k]
        return

      if !block.widget
        block.widget = {content: ""}
      else
        block.widget.content = content
  generateJSON: (block) ->
    blocksBuilder = $injector.get "blocksBuilder"
    result = {}
    self = @
    err "Can't recognize block" unless block
    if block.hasClass(ns.rowClass.substr(1))
      result.cols = []
      block.get("children").filter(ns.colClass).each (block) ->
        result.cols.push self.generateJSON(block)
    else if block.hasClass(ns.colClass.substr(1)) or block.hasClass(ns.wrapperClass.substr(1))
      (if block.test("[class*='str-col-']") then result.size = blocksBuilder.getColSize(block))
      widgets = []
      rows = []
      block.get("children").each ((block) ->
        if block.test(ns.rowClass)
          0 isnt widgets.length and (rows.push(cols: [
            size: result.size
            widgets: $rootScope.Y.clone(widgets, true)
           ])
          widgets = []
          )
          rows.push(self.generateJSON(block))
        else if block.test(ns.blockClass)
          block = block.widget
          err "Block has not json" unless block
          widgets.push block
      )
      if 0 is rows.length then result.widgets = widgets else (0 isnt widgets.length and !result.size and err("Col size is invalid: ", result.size)
      if result.size and widgets.length
        rows.push(cols: [
          size: result.size
          widgets: $rootScope.Y.clone(widgets, true)
        ])
      result.rows = rows
      )
    if result.rows and 0 is result.rows.length or result.cols and 0 is result.cols.length
      delete result.rows
      delete result.cols
      result.widgets = []
      block.get("children").filter(ns.blockClass).each (block) ->
        result.widgets.push(block.widget)
    return result


]



// WEBPACK FOOTER //
// ./src/app/editor/api/sectionemail.coffee